<!-- Selected Proposal View -->
@if (proposal()) {
  <mat-card appearance="outlined">
    <mat-card-content class="flex justify-between content-center items-center">
      <div>
        @if (proposal().lenders.length > 1) {
          <div class="img-title flex justify-center content-center items-center">
            <mat-icon>filter_{{proposal().lenders.length}}</mat-icon>
          </div>
        }
        @if (proposal().lenders.length === 1) {
          <div class="img-title flex justify-center content-center items-center">
            <img src="/assets/logos/{{proposal().lenders[0].lenderName | lowercase}}.png" alt="{{proposal().lenders[0].lenderName}}">
          </div>
        }
      </div>
      <div class="small-text gray">
        @for (lender of proposal().lenders; track lender; let i = $index) {
          <span>
            {{lender.lenderName}} {{lender.rate}}
            @if (i < proposal().lenders.length - 1) {
              ,
            }
          </span>
        }
        ({{ proposal().interestRate | number:'1.2-2'}}%)
      </div>
    </mat-card-content>
  </mat-card>
}